const closeButton = document.getElementById('closeBtn');
const videoPlayer = document.getElementById('videoPlayer');
const videoPreview = document.getElementById('videoPreview');

const playButtonList = document.querySelectorAll('#playButton');

if (playButtonList) {
  playButtonList.forEach((playBtn) => {
    playBtn.addEventListener('click', () => {
      const videoSrc = playBtn.getAttribute('data-video-src');
      videoPlayer.style.display = 'block';
      if (playBtn.classList.contains('hasYtShort')) {
        if (window.innerWidth <= 580) {
          videoPlayer.style.width = '335px';
          videoPlayer.style.height = '540px';
        } else {
          videoPlayer.style.width = '354px';
          videoPlayer.style.height = '630px';
        }
      } else {
        videoPlayer.style.removeProperty('width');
        videoPlayer.style.removeProperty('height');
      }
      document.body.classList.add('popup-open');
      document.getElementById('innerFrame').innerHTML = `<iframe id="frame" src="${videoSrc}?autoplay=1&rel=0&modestbranding=1" title="WellReceived - 24/7 Medical Reception Service - Caring is the Answer" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      videoPreview.pause();
    });
  });
}

if (closeButton) {
  closeButton.onclick = () => {
    videoPlayer.style.display = 'none';
    document.body.classList.remove('popup-open');
    document.getElementById('frame').src = '';
    videoPreview.play();
  };
}
